import React from "react";
import { media } from "core/stylesheet";
import styled from "styled-components";

const MenuWrap = styled.div`
  ${media.phone`right: auto; width: 100%; top: 0;`} background-color: #fff;
  width: 200px;
  top: 74px;
  right: 5.5rem;
  position: fixed;
  @media (max-width: 960px) {
    right: auto;
    width: 100%;
    top: 0;
    position: absolute;
  }
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: -5px;
    left: 48%;
    width: 10px;
    height: 10px;
    background: #fff;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    transform: rotate(-135deg);
    @media (max-width: 960px) {
      display: none;
    }
  }
`;
const Wrap = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`;

export default ({
  onSignOut,
  pushToDashboard,
  pushToProfile,
  pushToInvitation,
  MenuLinks
}) => (
  <Wrap>
    <MenuWrap className="z-999 db-ns shadow-4 center-h-absolute-ns absolute-ns bg-white ba ph3 br3-ns br0-m br0 b--light-gray">
      <div className="flex flex-column">{MenuLinks}</div>
    </MenuWrap>
  </Wrap>
);



// WEBPACK FOOTER //
// ./src/components/generic/layout/Menu/index.js